import { HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';
import {
  PlacingTeaserBetRequest,
  PointLevelResponse,
  PointTeamResponse,
  TeaserPointResponse,
} from 'models/teaser';

const teaserApi = {
  getTeamPoints: (): Promise<HttpResponse<PointTeamResponse[]>> => {
    const url = '/terabet/api/teaser/teams';
    return handleRequest(axiosClient.get(url));
  },
  getLevelPoints: (): Promise<HttpResponse<PointLevelResponse[]>> => {
    const url = '/terabet/api/teaser/levels';
    return handleRequest(axiosClient.get(url));
  },
  getTeaserPoint: (): Promise<HttpResponse<TeaserPointResponse[]>> => {
    const url = '/terabet/api/teaser';
    return handleRequest(axiosClient.get(url));
  },
  placeTeaserBets: (request: PlacingTeaserBetRequest) => {
    const url = `/terabet/api/bets/teaser`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
};

export default teaserApi;
